import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT, SELECTION_TYPE } from '../../../../../framework/grid/GridFw';
import { BasePage } from '../../../../../framework/pages/BasePage';
import { MessageUtil } from '../../../../../util/MessageUtil';
import FormGridFw, { FORM_GRID_MODE } from '../../../../../framework/form-grid/FormGridFw';
import { LoadUtil } from '../../../../../framework/util/LoadUtil';
import { getValidationEstacionModal } from './getValidationEstacionModal';
import { EnvConstants } from '../../../../../EnvConstants';

export class AgregarTitularFacturaModal extends BasePage {
    constructor(props) {
        super(props);
        this.titularFacturaForm = {};
    };

    createPageProperties = (pageApi) => {
        return {
            validation: getValidationEstacionModal,
        };
    }

    renderPage(pageApi) {
        const validarForm = () => {
            if (this.titularFacturaForm.nombre_titular_factura === "" || !this.titularFacturaForm.nombre_titular_factura) {
                MessageUtil(
                    "warning",
                    "Alerta!",
                    "Seleccione un Titular de Facturación."
                );
                
                return false;
            }
            return true;
        }

        const barButtonconfig = {
            fields:[
                {...BUTTON_DEFAULT.SAVE , onClick: () => {
                    
                    if (validarForm()) {
                        const data = {
                            id_empresa: pageApi.name.data.id_empresa,
                            id_titular: this.titularFacturaForm.nombre_titular_factura,
                            id_division: 1,
                        };

                        LoadUtil.loadByQueryId({
                            url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
                            queryId: 867,
                            params: data,
                            fnOk: (res) => {
                                if(!res?.error) {
                                    MessageUtil("success", res.msg, "");
                                    pageApi.hideThisModal();
                                    pageApi.name.fnLoadForm()
                                } else {
                                    MessageUtil("error", res.error, "");
                                }  
                            }
                        })
                    }
                }},
            ]
        }

        const formConfig = {
            mode: FORM_GRID_MODE.FORM_ADD,
            afterAddEvent: (data) => {
                pageApi.getEvent('afterAddEvent')(data);
                pageApi.hideThisModal();
            },
            form: {
                fields:[
                    {
                        name:'titular_factura',
                        type: 'select',
                        label:'Titular Factura',
                        column: 12,
                        search: true,
                        load: { queryId: 866 },
                        onChange: (value, values) => { this.titularFacturaForm.nombre_titular_factura = value },
                        required: true
                    },
                ]
            },
            bar: barButtonconfig
        } 

    
        return (
            <>
                <FormFw
                    name="grupoFacturaForm" 
                    getParentApi={pageApi.getApi}
                    config={formConfig.form}
                />
                <BarButtonFw
                    name="bar"
                    getParentApi={pageApi.getApi}
                    config={barButtonconfig}
                />
            </>
        )

    }
    
}